"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _web = require("@react-spring/web");
var _constants = require("./constants");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AnimatedWrapper = _ref => {
  let {
    children,
    isOpen,
    isAboveTrigger,
    onOpened,
    onClosed
  } = _ref;
  const hasClosed = (0, _react.useRef)();
  const {
    openStyles,
    closedStyles
  } = (0, _react.useMemo)(() => {
    const slideStartPosition = isAboveTrigger ? _constants.ANIMATION_SLIDE_AMOUNT : 0 - _constants.ANIMATION_SLIDE_AMOUNT;
    return {
      closedStyles: {
        opacity: 0,
        transform: "translateY(".concat(slideStartPosition, "px)")
      },
      openStyles: {
        opacity: 1,
        transform: "translateY(0px)"
      }
    };
  }, [isAboveTrigger]);
  (0, _react.useEffect)(() => () => {
    if (hasClosed.current === false) {
      onClosed === null || onClosed === void 0 || onClosed();
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const transitions = (0, _web.useTransition)(isOpen, {
    from: closedStyles,
    enter: {
      ...openStyles,
      onRest: () => {
        if (isOpen) {
          hasClosed.current = false;
          onOpened === null || onOpened === void 0 || onOpened();
        }
      }
    },
    leave: {
      ...closedStyles,
      onRest: () => {
        if (!isOpen) {
          hasClosed.current = true;
          onClosed === null || onClosed === void 0 || onClosed();
        }
      }
    },
    config: {
      duration: _constants.ANIMATION_DURATION
    }
  });
  return transitions((props, item) => item && (0, _react2.jsx)(_web.animated.div, {
    style: props
  }, children));
};
AnimatedWrapper.displayName = 'AnimatedWrapper';
var _default = exports.default = AnimatedWrapper;